import {EntitySocialResponse} from '../../backend/interfaces/entity-social-response';
import {User} from '../../backend/interfaces/user';
import {Option} from '../../components/select-dropdown/select-dropdown';

export type SeniorOption = Option & {originalData: User; socialResponses: EntitySocialResponse[]};

export type SeniorsList = Map<string, SeniorOption>;

export interface SeniorSidebarState {
  senior?: SeniorOption | null;
  list?: SeniorsList | null;
}

export enum SeniorSidebarActionType {
  SET_SENIOR_LIST = 'SET_SENIOR_LIST',
  UPDATE_SENIOR_LIST = 'UPDATE_SENIOR_LIST',
  SET_SELECTED_SENIOR = 'SET_SELECTED_SENIOR',
}

export type SeniorSidebarAction =
  | {
      type: SeniorSidebarActionType.SET_SENIOR_LIST;
      list: SeniorsList;
    }
  | {
      type: SeniorSidebarActionType.SET_SELECTED_SENIOR;
      senior: SeniorOption;
    }
  | {
      type: SeniorSidebarActionType.UPDATE_SENIOR_LIST;
      list: SeniorsList;
    };

export interface SeniorSiderbarType {
  state: SeniorSidebarState;
  updateSeniorData: (user: User, socialResponses?: EntitySocialResponse[]) => void;
}
